class CartDrawer extends Cart {
  constructor() {
    super();

    this._onDrawerOpened = this.openDrawer.bind(this);
    this._onDrawerClosed = this.closeDrawer.bind(this);
    this._onResize = this.setDrawerHeight.debounce(50);
  }

  get selectors() {
    return {
      ...super.selectors,
      section: "cart-drawer",
      drawer: {
        button: {
          open: "[data-cart-drawer-open]",
          close: "[data-cart-drawer-close]"
        },
        scrollableContent: "[data-cart-drawer-scrollable]"
      }
    }
  }

  get modifiers() {
    return {
      ...super.modifiers,
      drawer: {
        open: "cart-drawer--open"
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();

    document.documentElement.customDelegate(
      "click",
      this.selectors.drawer.button.open,
      this._onDrawerOpened
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.drawer.button.close,
      this._onDrawerClosed
    );

    document.addEventListener("cart-drawer:open", this._onDrawerOpened);
    document.addEventListener("cart-drawer:close", this._onDrawerClosed);

    window.addEventListener("resize", this._onResize);

    if (!isThemeDesignMode()) {
      this.setAttribute("inert", "");
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeTrapFocus();
    this.restoreBackground();

    document.removeEventListener("cart-drawer:open", this._onDrawerOpened);
    document.removeEventListener("cart-drawer:close", this._onDrawerClosed);

    window.removeEventListener("resize", this._onResize);
  }

  openDrawer(event) {
    event.preventDefault();

    const opener = document.activeElement;
    const scrollableContent = this.querySelector(this.selectors.drawer.scrollableContent);

    bodyScrollLock.disableBodyScroll(scrollableContent);

    this.removeAttribute("inert");
    this.classList.add(this.modifiers.drawer.open);
    this.inertBackground();
    this.trapFocus();
    this.focusDrawer(opener);
  }

  closeDrawer(event) {
    event.preventDefault();

    const scrollableContent = document.querySelector(this.selectors.drawer.scrollableContent);

    this.classList.remove(this.modifiers.drawer.open);
    this.removeTrapFocus();
    this.restoreBackground();

    if (!isThemeDesignMode()) {
      this.setAttribute("inert", "");
    }

    bodyScrollLock.clearAllBodyScrollLocks();

    this.returnFocusToPreviousElement();
  }

  setDrawerHeight() {
    const cartDrawerHeight = window.innerHeight;

    document.documentElement.style.setProperty(
      '--cart-drawer-height',
      `${cartDrawerHeight}px`
    );
  }

  focusDrawer(opener) {
    if (opener && !this.contains(opener)) {
      this.previouslyFocusedElement = opener;
    }

    this.focus({
      preventScroll: true
    });
  }

  returnFocusToPreviousElement() {
    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}